/*!
 * ScrollToPlugin 3.12.0
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var e, K, c, f, p, L, O, h, C = function() {
  return typeof window < "u";
}, B = function() {
  return e || C() && (e = window.gsap) && e.registerPlugin && e;
}, G = function(i) {
  return typeof i == "string";
}, b = function(i) {
  return typeof i == "function";
}, g = function(i, o) {
  var r = o === "x" ? "Width" : "Height", s = "scroll" + r, l = "client" + r;
  return i === c || i === f || i === p ? Math.max(f[s], p[s]) - (c["inner" + r] || f[l] || p[l]) : i[s] - i["offset" + r];
}, T = function(i, o) {
  var r = "scroll" + (o === "x" ? "Left" : "Top");
  return i === c && (i.pageXOffset != null ? r = "page" + o.toUpperCase() + "Offset" : i = f[r] != null ? f : p), function() {
    return i[r];
  };
}, F = function(i, o, r, s) {
  if (b(i) && (i = i(o, r, s)), typeof i != "object")
    return G(i) && i !== "max" && i.charAt(1) !== "=" ? {
      x: i,
      y: i
    } : {
      y: i
    };
  if (i.nodeType)
    return {
      y: i,
      x: i
    };
  var l = {}, n;
  for (n in i)
    l[n] = n !== "onAutoKill" && b(i[n]) ? i[n](o, r, s) : i[n];
  return l;
}, R = function(i, o) {
  if (i = L(i)[0], !i || !i.getBoundingClientRect)
    return console.warn("scrollTo target doesn't exist. Using 0") || {
      x: 0,
      y: 0
    };
  var r = i.getBoundingClientRect(), s = !o || o === c || o === p, l = s ? {
    top: f.clientTop - (c.pageYOffset || f.scrollTop || p.scrollTop || 0),
    left: f.clientLeft - (c.pageXOffset || f.scrollLeft || p.scrollLeft || 0)
  } : o.getBoundingClientRect(), n = {
    x: r.left - l.left,
    y: r.top - l.top
  };
  return !s && o && (n.x += T(o, "x")(), n.y += T(o, "y")()), n;
}, A = function(i, o, r, s, l) {
  return !isNaN(i) && typeof i != "object" ? parseFloat(i) - l : G(i) && i.charAt(1) === "=" ? parseFloat(i.substr(2)) * (i.charAt(0) === "-" ? -1 : 1) + s - l : i === "max" ? g(o, r) - l : Math.min(g(o, r), R(i, o)[r] - l);
}, m = function() {
  e = B(), C() && e && typeof document < "u" && document.body && (c = window, p = document.body, f = document.documentElement, L = e.utils.toArray, e.config({
    autoKillThreshold: 7
  }), O = e.config(), K = 1);
}, k = {
  version: "3.12.0",
  name: "scrollTo",
  rawVars: 1,
  register: function(i) {
    e = i, m();
  },
  init: function(i, o, r, s, l) {
    K || m();
    var n = this, _ = e.getProperty(i, "scrollSnapType");
    n.isWin = i === c, n.target = i, n.tween = r, o = F(o, s, i, l), n.vars = o, n.autoKill = !!o.autoKill, n.getX = T(i, "x"), n.getY = T(i, "y"), n.x = n.xPrev = n.getX(), n.y = n.yPrev = n.getY(), h || (h = e.core.globals().ScrollTrigger), e.getProperty(i, "scrollBehavior") === "smooth" && e.set(i, {
      scrollBehavior: "auto"
    }), _ && _ !== "none" && (n.snap = 1, n.snapInline = i.style.scrollSnapType, i.style.scrollSnapType = "none"), o.x != null ? (n.add(n, "x", n.x, A(o.x, i, "x", n.x, o.offsetX || 0), s, l), n._props.push("scrollTo_x")) : n.skipX = 1, o.y != null ? (n.add(n, "y", n.y, A(o.y, i, "y", n.y, o.offsetY || 0), s, l), n._props.push("scrollTo_y")) : n.skipY = 1;
  },
  render: function(i, o) {
    for (var r = o._pt, s = o.target, l = o.tween, n = o.autoKill, _ = o.xPrev, Y = o.yPrev, w = o.isWin, E = o.snap, S = o.snapInline, y, x, P, X, u; r; )
      r.r(i, r.d), r = r._next;
    y = w || !o.skipX ? o.getX() : _, x = w || !o.skipY ? o.getY() : Y, P = x - Y, X = y - _, u = O.autoKillThreshold, o.x < 0 && (o.x = 0), o.y < 0 && (o.y = 0), n && (!o.skipX && (X > u || X < -u) && y < g(s, "x") && (o.skipX = 1), !o.skipY && (P > u || P < -u) && x < g(s, "y") && (o.skipY = 1), o.skipX && o.skipY && (l.kill(), o.vars.onAutoKill && o.vars.onAutoKill.apply(l, o.vars.onAutoKillParams || []))), w ? c.scrollTo(o.skipX ? y : o.x, o.skipY ? x : o.y) : (o.skipY || (s.scrollTop = o.y), o.skipX || (s.scrollLeft = o.x)), E && (i === 1 || i === 0) && (x = s.scrollTop, y = s.scrollLeft, S ? s.style.scrollSnapType = S : s.style.removeProperty("scroll-snap-type"), s.scrollTop = x + 1, s.scrollLeft = y + 1, s.scrollTop = x, s.scrollLeft = y), o.xPrev = o.x, o.yPrev = o.y, h && h.update();
  },
  kill: function(i) {
    var o = i === "scrollTo";
    (o || i === "scrollTo_x") && (this.skipX = 1), (o || i === "scrollTo_y") && (this.skipY = 1);
  }
};
k.max = g;
k.getOffset = R;
k.buildGetter = T;
B() && e.registerPlugin(k);
export {
  k as S
};
